import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Icon from '../Icon'

const styles = theme => ({
  root: {
    borderRadius: 0,
    padding: `${theme.spacing(6)} ${theme.spacing(4)}`,
    border: '1px solid #e0e0e0',
  },
  label: {
    color: `var(--gameday-body-headingColor, ${theme.body.headingColor})`,
    fontWeight: theme.typography.fontWeightBolder,
    fontSize: theme.typography.fontSizeMed,
  },
  stgIcon: {
    float: 'right',
  },
  cardContent: {
    marginTop: theme.spacing(4),
  },
})

const STGCard = ({ children, classes, className, iconName, iconSize, iconType, label, showIcon, ...rest }) => (
  <section className={cn(classes.root, className)} {...rest}>
    <div className={classes.labelDiv}>
      <span className={classes.label}>{label}</span>
      {showIcon && <Icon iconName={iconName} iconType={iconType} className={classes.stgIcon} iconSize={iconSize} />}
    </div>
    <div className={classes.cardContent}>{children}</div>
  </section>
)

STGCard.defaultProps = {
  iconName: 'settingsFilled',
  iconSize: 24,
  iconType: 'disabled',
}

const CardComponent = withStyles(styles)(STGCard)
CardComponent.displayName = 'Modal'
export default CardComponent
